import { render, staticRenderFns } from "./gzh-dialog.vue?vue&type=template&id=664b0e2b&scoped=true&"
import script from "./gzh-dialog.vue?vue&type=script&lang=js&"
export * from "./gzh-dialog.vue?vue&type=script&lang=js&"
import style0 from "./gzh-dialog.vue?vue&type=style&index=0&id=664b0e2b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "664b0e2b",
  null
  
)

export default component.exports